/* jshint esversion: 6 */
/* jshint esversion: 8 */
import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import {getDatabase} from 'firebase/database';
import {getMessaging,getToken} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDI0H7HXm-aP1TTQXzLZfHV98mnK9v8NCs",
  authDomain: "studio-67236.firebaseapp.com",
  projectId: "studio-67236",
  storageBucket: "studio-67236.appspot.com",
  messagingSenderId: "324152946798",
  appId: "1:324152946798:web:316c489e86610ffb15f67f",
  measurementId: "G-1H6CJZPYQ6"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const database = getDatabase(app);

const vapidKey = "BBeGwOVXkJxZbDM0ejqdRLINKHp834QGmMeaVpeSulMeD28OUIQ2QHlG1Ew_U6ejitDIQV_E3zDuCZ_SnyRNd8E";
const messaging = getMessaging(app);

export const RecvestToken = async () => {
  return Notification.requestPermission()
  .then((permission) => {
    if(permission === "granted") {
      const Token = getToken(messaging,{ vapidKey });
      return Token;
    }
  });
};

export { db, auth, database, messaging };